import React, { useEffect, useState } from "react";
import { SocketConnectionBase } from "./SocketConnectionBase";

export const SocketConnection = () => {
    const [attrs, setAttrs] = useState({
        vtPusherAppId: "",
        vtPusherKey: "",
        vtPusherSecret: "",
        vtPusherCluster: "",
        vtPusherChannel: "",
        vtPusherEvent: "",
    });

    // Cargar parámetros desde VTWidgetBridge
    useEffect(() => {
        const bridge = window?.VTWidgetBridge?.Bridge;
        if (!bridge) {
            console.error("VTWidgetBridge no disponible en window.");
            return;
        }

        bridge
            .getAttributes([
                "vtPusherAppId",
                "vtPusherKey",
                "vtPusherSecret",
                "vtPusherCluster",
                "vtPusherChannel",
                "vtPusherEvent",
            ])
            .defaultValues({
                vtPusherAppId: "2037409",
                vtPusherKey: "bf3032a9613513a94959",
                vtPusherSecret: "dbcccbe2240fad87591",
                vtPusherCluster: "eu",
                vtPusherChannel: "BOMancity",
                vtPusherEvent: "showUserInBackOffice",
            })
            .then((a) => setAttrs(a));
    }, []);

    return <SocketConnectionBase attrs={attrs} />;
};
